'use strict';

function isInWebview() {
    return typeof inWebview !== 'undefined' && inWebview;
}